var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_947_1936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6025 13.4166H0.812903C0.446333 13.4166 0.166016 13.139 0.166016 12.776V1.22385C0.166016 0.860845 0.446333 0.583252 0.812903 0.583252H6.24676C6.61332 0.583252 6.89364 0.860845 6.89364 1.22385V4.89662H10.6025C10.969 4.89662 11.2493 5.17421 11.2493 5.53722V12.776C11.2493 13.1176 10.969 13.4166 10.6025 13.4166ZM1.45979 12.1354H9.95558V6.17782H6.24676C5.88019 6.17782 5.59987 5.90022 5.59987 5.53722V1.86445H1.45979V12.1354Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6022 6.17782C10.4297 6.17782 10.2788 6.11376 10.1494 5.98564L5.79368 1.67227C5.53492 1.41603 5.53492 1.01032 5.79368 0.775432C6.05243 0.519192 6.46213 0.519192 6.69932 0.775432L11.055 5.06744C11.3138 5.32368 11.3138 5.7294 11.055 5.96428C10.9256 6.11376 10.7747 6.17782 10.6022 6.17782Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40285 10.8115H3.01212C2.64555 10.8115 2.36523 10.5339 2.36523 10.1709C2.36523 9.80787 2.64555 9.53027 3.01212 9.53027H8.38128C8.74785 9.53027 9.02817 9.80787 9.02817 10.1709C9.02817 10.5339 8.74785 10.8115 8.40285 10.8115Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40285 8.48408H3.01212C2.64555 8.48408 2.36523 8.20649 2.36523 7.84348C2.36523 7.48047 2.64555 7.20288 3.01212 7.20288H8.38128C8.74785 7.20288 9.02817 7.48047 9.02817 7.84348C9.02817 8.20649 8.74785 8.48408 8.40285 8.48408Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37058 6.17793H3.01212C2.64555 6.17793 2.36523 5.90033 2.36523 5.53733C2.36523 5.17432 2.64555 4.89673 3.01212 4.89673H4.37058C4.73715 4.89673 5.01747 5.17432 5.01747 5.53733C5.01747 5.90033 4.73715 6.17793 4.37058 6.17793Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_947_1936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.0833,
    height: 12.8333,
    fill: "none",
    transform: "translate(0.166016 0.583252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/ReportIcon.69d1c7f98cfb8f35e3848506a916bcde.svg";
export { ForwardRef as ReactComponent };